<template>
  <div class="container m-5 pb-5 basics-20-bg" style="min-height:87%">
    <div class="row mt-3">
      <div class="col-md-10">
        <h3 style="text-transform: capitalize;">
          {{ user.user_info.gender | pronom }} {{ user.user_info.given_name }} {{ user.user_info.family_name }}
          <button v-if="DEBUG" type="button" class="btn btn-link btn-sm text-sm align-middle mb-1" @click="resetFakeDate">
            Reset
          </button>
        </h3>
        <h5>Né(e) le {{ moment(user.user_info.birthdate).format('DD/MM/YYYY') }} </h5>
      </div>
    </div>

    <div class="row mt-4 text-sm col-md-10">
      <div class="my-2 w-100">
        <h5 class="text-primary">
          L'entrepôt de données de santé
        </h5>
        En vertu de l'article 56 de la loi Informatique et Libertés, je souhaite m'opposer à ce que des données à caractère personnel me concernant fassent l'objet de traitements automatisés ayant pour finalité la recherche.<br>
        Etant entendu que cette opposition n'influencera en rien la qualité des soins qui me seront prodigués. <br>
      </div>
      <div
        v-for="paragraph in paragraphs"
        :key="paragraph.id"
        class="my-2 w-100"
      >
        <h5 class="text-primary">
          {{ paragraph.title }}
        </h5>
        {{ paragraph.content }}
      </div>
      <div v-if="opposition.opposition_status === 'not_opposed'">
        <button class="btn btn-primary btn-sm mt-3" @click="showModalGlobalOpposition = true">
          Je m'oppose
        </button>
      </div>
      <div v-else class="mt-3">
        <b class="text-danger">Votre opposition à été enregistrée le {{ moment(opposition.date).format('DD/MM/YYYY') }}</b><br>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-md-10 text-sm">
        <h5 class="text-primary">
          Les protocoles de recherche
        </h5>
        Inclus dans {{ maps.length }} protocole(s) de recherche. <br>
        Opposition enregistrée pour {{ opposedMaps.length }} protocole(s) de recherche <br>
        <div v-for="map in maps" :key="map.id" class="card accordion mt-3">
          <div :id="'header_' + map.id" class="card-header" style="background-color: inherit;">
            <div class="row">
              <div class="col-8">
                <h6>{{ map.workspace.title }}</h6>
              </div>
              <div class="col float-right">
                <span v-if="map.workspace.definition_status === 'validated'" class="float-right badge badge-success ml-2">
                  En cours
                </span>
                <span v-else class="float-right badge badge-danger ml-2">
                  Projet clôturé
                </span>
                <span v-if="map.workspace.definition_status === 'validated' && map.workspace?.opposition_state === 'open'" class="float-right badge badge-success">
                  Oppositions ouvertes
                </span>
                <span v-if="map.workspace.definition_status === 'validated' && map.workspace?.opposition_state === 'close'" class="float-right badge badge-danger">
                  Oppositions clôturées
                </span>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-9">
                <div class="pl-0 btn btn-link collapsible collapsed" data-toggle="collapse" :data-target="'#collapse_' + map.id">
                  Plus d'informations
                </div>
              </div>
              <div class="col float-right">
                <label v-if="map.opposition_status !== 'not_opposed'" class="text-center" style="font-size:.75rem;">Opposition enregistrée</label>
              </div>
            </div>
          </div>
          <div :id="'collapse_' + map.id" class="card-body collapse">
            <div class="row">
              <div class="col">
                Date d'inclusion dans le protocole : {{ moment(map.date).format('DD/MM/YYYY') }}
                <br>
                <div v-if="map.workspace.eds_choice === 'without_eds'">
                  <br>
                  <span>Ce projet a été créé sans espace de travail</span>
                  <br>
                </div>
                <br>
                <span class="text-sm">
                  {{ map.workspace.description }}
                </span>
              </div>
            </div>
            <div v-if="map.workspace.definition_status === 'validated'">
              <button v-if="map.opposition_status === 'not_opposed' && map.workspace.opposition_state === 'open'" type="button" class="btn btn-primary btn-sm mt-3 text-sm float-right" @click="projectOpposition = map; showModalProjectOpposition = true;">
                Je m'oppose
              </button>
              <div v-else-if="map.workspace.opposition_state === 'close'" class="mt-3">
                <b class="text-danger">Les oppositions ont été clôturées pour ce projet, pour plus d’informations, veuillez contacter le DPO de votre établissement.</b><br>
              </div>
              <div v-else class="mt-3">
                <b class="text-success">Votre opposition à été enregistrée.</b><br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pop-in-global-opposition
      v-if="showModalGlobalOpposition" @close-modal="showModalGlobalOpposition = false"
      @validation="registerGlobalOpposition()"
    />
    <pop-in-project-opposition
      v-if="showModalProjectOpposition" @close-modal="showModalProjectOpposition = false"
      @validation="updateMap(projectOpposition)"
    />
  </div>
</template>

<script>
import AuthService from '../services/auth.service';
import {OppositionDrwh, OppositionProtocols, ResetFakeData, CustomParagraphs} from '@/APIService';
import PopInGlobalOpposition from "@/components/PopInGlobalOpposition";
import PopInProjectOpposition from "@/components/PopInProjectOpposition";
import {DEBUG} from '@/parameters';
import moment from "moment";

export default {
  name: 'Profil',
  components: {PopInProjectOpposition, PopInGlobalOpposition},
  data() {
    return {
      opposition: {},
      maps: [],
      showModalGlobalOpposition: false,
      showModalProjectOpposition: false,
      projectOpposition: null,
      paragraphs: null,
      DEBUG,
      moment
    };
  },

  computed: {
    user() {
      return AuthService.getUserInfos();
    },

    opposedMaps() {
      return this.maps.filter(map => {
        return map.opposition_status === "opposed";
      });
    },

    gddiId(){
      return AuthService.getGddiId();
    }
  },

  mounted() {
    this.getMaps();
    this.getGlobalOpposition();
    this.getCustomParagraphs();
  },

  methods: {
    registerGlobalOpposition() {
      OppositionDrwh.partial_update(
          this.gddiId, {"opposition_status": "opposed"}
      ).then(
          opposition => (this.opposition = opposition)
      );
    },

    updateMap(map) {
      OppositionProtocols.partial_update(map.workspace.identifier, {"opposition_status": "opposed"}).then(() => {
        this.getMaps();
      });
    },

    getMaps() {
      return OppositionProtocols.list().then(maps => (this.maps = maps));
    },

    getGlobalOpposition() {
      return OppositionDrwh.retrieve(this.gddiId).then(opposition => (this.opposition = opposition));
    },

    getCustomParagraphs() {
      CustomParagraphs.list().then(response => {
        this.paragraphs = response;
      });
    },

    resetFakeDate() {
      return ResetFakeData.create().then( () => {
        this.getMaps();
        this.getGlobalOpposition();
        window.scrollTo(0,0);
      });
    }
  }
};
</script>

<style>

</style>
